// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search_Search_2a-1u"};